import { createContext } from 'react';
const SortContext = createContext({
    descend: false,
    orderBy: 'name',
    setDescend: () => { },
    setOrderBy: () => { },
});
export default SortContext;
